import { Event, EventDispatcher, eventDispatcher } from '@optimizely/optimizely-sdk'

export const eventProxy: EventDispatcher = {
  dispatchEvent(event: Event, callback: () => void): void {
    event.url = `${process.env.FRONTEND_EVENT_PROXY_HOST}/v1/events`
    eventDispatcher.dispatchEvent(event, callback)
  },
}
